<template>
  <div
    class="bg-white dark:bg-black w-full flex flex-col gap-y-24 items-center mx-auto"
  >
    <!-- Section-1 -->
    <div class="w-full max-w-7xl flex gap-y-6 flex-col lg:flex-row p-4">
      <!-- mobile/tablet -->
      <div class="lg:hidden flex flex-col gap-4 items-center w-full">
        <Logo variant="full" />

        <h1
          class="mt-[20px] text-center text-[47px] md:text-[62px] text-black dark:text-white font-bold leading-none"
        >
          Chat. Photos.
          <br />
          Videos.
          <span
            class="text-[#f2699b] italic font-bold text-[47px] md:text-[62px] tracking-[-0.25rem] font-serif"
          >
            Privacy.
          </span>
        </h1>
        <h2
          class="w-full max-w-[400px] text-[22px] text-center text-[#828282] leading-none text-2xl/8 tracking-tight"
        >
          Connect and explore exclusive content from your favorite creators.
        </h2>
      </div>

      <!-- desktop -->
      <div class="hidden lg:flex w-1/2 relative overflow-clip">
        <div class="flex bg-[#fbeff3] dark:bg-[#2B3236] rounded-[32px] p-10">
          <div class="flex flex-col gap-5">
            <Logo variant="full" />
            <h1
              class="mt-[20px] text-left text-[62px] text-black dark:text-white font-bold leading-none"
            >
              Chat. Photos.
              <br />
              Videos.
              <span
                class="text-[#f2699b] italic font-bold text-[62px] tracking-[-0.25rem] font-serif"
              >
                Privacy.
              </span>
            </h1>
            <h2 class="text-[27px] text-[#828282]">
              Connect and explore exclusive content from your favorite creators.
            </h2>
          </div>

          <HeartMatrix />
        </div>
      </div>

      <div
        class="flex flex-col justify-center items-center gap-y-4 w-full lg:w-1/2"
      >
        <div
          class="flex justify-center items-center w-full md:w-[400px] m-auto"
        >
          <JoinForm />
        </div>
        <p class="text-center text-black dark:text-white">
          Already have an account?
          <NuxtLink to="/login" class="text-primary-600">Sign In</NuxtLink>
        </p>
      </div>
      <UNotifications />
    </div>

    <!-- Section-2 -->
    <div
      class="w-full max-w-7xl flex flex-col lg:flex-row items-center justify-center gap-6 p-4"
    >
      <div class="w-full md:w-1/2 h-full flex items-center justify-center">
        <div class="w-full flex items-center justify-center gap-3">
          <img
            class="size-[130px] md:size-[150px] lg:size-[125px] rounded-[22px] object-cover transform rotate-[-16deg] translate-y-4 translate-x-4 z-10"
            src=" /images/redesign-temp/girl-s2-p1.jpg"
          />

          <div
            class="relative shrink-0 overflow-hidden size-[180px] md:size-[240px] rounded-[22px] z-20"
          >
            <img class="size-full" src="/images/redesign-temp/girl-s2-p2.jpg" />
            <div class="absolute inset-0 backdrop-filter backdrop-blur-md" />
            <div
              class="absolute inset-0 flex flex-col items-center justify-center gap-2"
            >
              <font-awesome-icon
                icon="fa-solid fa-lock"
                class="text-white text-3xl font-semibold"
              />
              <span>Click to Unlock</span>
            </div>
          </div>

          <img
            class="size-[130px] md:size-[150px] lg:size-[125px] rounded-[22px] object-cover transform rotate-[16deg] translate-y-4 -translate-x-4 z-10"
            src="/images/redesign-temp/girl-s2-p3.jpg"
          />
        </div>
      </div>

      <div
        class="flex flex-col w-full md:w-1/2 items-center lg:items-start gap-6 py-12 md:py-24"
      >
        <h1
          class="text-3xl md:text-5xl lg:text-6xl text-center lg:text-left font-semibold letter-spacing-tight leading-none"
        >
          Get
          <span class="text-[#f2699b]">exclusive</span>
          content
        </h1>
        <h2
          class="text-[#828282] text-center lg:text-left text-[16px] lg:text-[24px] leading-tight tracking-tighter"
        >
          Make all your hot dreams come true with all exclusive content from
          creators.
        </h2>

        <a
          class="bg-[#F2699B] text-[#ffffff] p-[20px] rounded-[100px] text-[24px] leading-none flex items-center justify-center"
          href="#"
        >
          Become a Member
        </a>
      </div>
    </div>

    <!-- Section-3 -->
    <div
      class="w-full max-w-7xl flex flex-col lg:flex-row items-center justify-center gap-6 p-4 pb-24"
    >
      <div class="w-full lg:w-1/2 h-full flex items-center justify-center">
        <div
          class="w-[500px] xh-[402px] p-6 flex flex-col gap-y-8 text-[#2F2E2E] bg-[#FBEFF3] dark:bg-[#2B3236] rounded-3xl"
        >
          <p class="text-[16px] text-[#595858] dark:text-[#FFFFFF]">
            NEW MESSAGES
          </p>

          <!-- Chat-row-1 -->
          <div class="flex justify-between gap-x-4">
            <div class="flex gap-x-4">
              <img
                class="model-avatar rounded-[22px] w-[62px] h-[62px]"
                src="/images/redesign-temp/girl-s3-p1.jpg"
              />

              <div>
                <p
                  class="text-lg lg:text-xl text-[#2f2e2e] dark:text-[#ffffff] font-bold"
                >
                  EvaTease
                </p>
                <p
                  class="text-base lg:text-lg text-[#2f2e2e] dark:text-[#ffffff] leading-6"
                >
                  I miss you babe 💦💦💦
                </p>
              </div>
            </div>

            <div class="flex flex-col gap-y-2 min-w-[85px]">
              <p
                class="text-base text-[#F2699B] min-w-[75px] text-right leading-none tracking-tighter"
              >
                1 min ago
              </p>
              <div class="flex justify-end">
                <div
                  class="bg-[#F2699B] text-[#fff] rounded-full flex justify-center items-center w-[28px] h-[28px] text-base text-center"
                >
                  1
                </div>
              </div>
            </div>
          </div>

          <!-- Chat-row-2 -->
          <div class="flex justify-between gap-x-4">
            <div class="flex gap-x-4">
              <img
                class="model-avatar rounded-[22px] w-[62px] h-[62px]"
                src="/images/redesign-temp/girl-s3-p2.jpg"
              />

              <div>
                <p
                  class="text-lg lg:text-xl text-[#2f2e2e] dark:text-[#ffffff] font-bold"
                >
                  HotBlonde
                </p>
                <p
                  class="text-base lg:text-lg text-[#2f2e2e] dark:text-[#ffffff] leading-6"
                >
                  wanna have some fun?? 😈
                </p>
              </div>
            </div>

            <div class="flex flex-col gap-y-2 min-w-[85px]">
              <p
                class="text-base text-[#F2699B] min-w-[75px] text-right leading-none tracking-tighter"
              >
                10 min ago
              </p>
              <div class="flex justify-end">
                <div
                  class="bg-[#F2699B] text-[#fff] rounded-full flex justify-center items-center w-[28px] h-[28px] text-base text-center"
                >
                  4
                </div>
              </div>
            </div>
          </div>

          <!-- Chat-row-3 -->
          <div class="flex justify-between gap-x-4">
            <div class="flex gap-x-4">
              <img
                class="model-avatar rounded-[22px] w-[62px] h-[62px]"
                src="/images/redesign-temp/girl-s3-p3.jpg"
              />

              <div>
                <p
                  class="text-lg lg:text-xl text-[#2f2e2e] dark:text-[#ffffff] font-bold"
                >
                  HiddenDesire
                </p>
                <p
                  class="text-base lg:text-lg text-[#2f2e2e] dark:text-[#ffffff] leading-6"
                >
                  I was a really bad girl today...
                </p>
              </div>
            </div>

            <div class="flex flex-col gap-y-2 min-w-[85px]">
              <p
                class="text-base text-[#F2699B] text-right leading-none tracking-tighter"
              >
                24 min ago
              </p>
              <div class="flex justify-end">
                <div
                  class="bg-[#F2699B] text-[#fff] rounded-full flex justify-center items-center w-[28px] h-[28px] text-base text-center"
                >
                  2
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full lg:w-1/2 h-full flex items-center justify-center">
        <div class="flex flex-col gap-6">
          <h1
            class="text-3xl md:text-5xl lg:text-6xl text-center lg:text-left font-semibold tracking-tight leading-none"
          >
            <span class="text-[#f2699b]">Chat</span>
            with creators
          </h1>
          <h2
            class="text-[#828282] text-center lg:text-left text-[16px] lg:text-[24px] leading-tight tracking-tighter"
          >
            Connect with your favorites via
            <br class="lg:hidden" />
            direct messages - paid or for free!
          </h2>
          <a
            class="bg-[#F2699B] text-[#ffffff] p-[20px] self-center lg:self-start rounded-full text-[24px] leading-none flex items-center justify-center"
            href="#"
          >
            Chat Now
          </a>
        </div>
      </div>
    </div>

    <!-- Section-4 -->
    <div
      class="w-full max-w-7xl flex flex-col lg:flex-row gap-6 items-center justify-center p-4 pb-24"
    >
      <div class="w-full flex items-center justify-center">
        <div
          class="max-w-[500px] w-full s4-card flex flex-col gap-y-4 justify-center items-center rounded-xl relative bg-[#FBEFF3] dark:bg-[#2b3236] pb-[20px] pt-[20px]"
        >
          <div class="relative">
            <img
              class="size-[82px] md:size-[114px]"
              src="/images/redesign-temp/girl-s4-p1.svg"
            />
            <img
              class="absolute right-0 bottom-0"
              height="32"
              width="32"
              src="/images/redesign-temp/icon-dot.svg"
            />

            <div
              style="
                width: 170px;
                text-align: center;
                letter-spacing: -0.214px;
                line-height: 29.41px;
              "
              class="flex text-[16px] leading-tight p-1 pl-4 absolute inline-block rotate-[-15deg] left-[82px] top-[-40px] bg-[#e3f3d1] rounded-full text-[#2f2e2e]"
            >
              <img
                class="absolute size-[25px] fill-[#f0f0f0] left-[4px] bottom-[-2px] rotate-[10deg] z-0"
                src="/images/redesign-temp/Union.svg"
                width="25"
                height="22"
              />
              <p class="flex z-10">
                I missed you 😈
                <img
                  src="/images/redesign-temp/icon-red-checks.svg"
                  width="22"
                  height="22"
                />
              </p>
            </div>
          </div>

          <img
            class="size-[120px] md:size-[120px] lg:size-[120px] absolute top-[-30px] left-[-5px] rounded-[10px] rotate-[-8deg]"
            src="/images/redesign-temp/girl-s2-p3.jpg"
          />
          <img
            class="size-[80px] md:size-[80px] lg:size[80px] absolute top-[50px] right-[0] rounded-[10px] rotate-[16deg]"
            src="/images/redesign-temp/girl-s2-p2.jpg"
          />

          <div class="flex flex-col gap-y-1 items-center justify-center">
            <p
              class="text-[27px] font-bold flex items-center justify-center gap-x-2"
            >
              EvaTease
              <img
                src="/images/redesign-temp/icon-star-check.svg"
                width="25"
                height="25"
              />
            </p>
            <p class="s4-card-model-social">@evatease</p>
          </div>

          <a
            class="flex items-center justify-center font-bold pt-[15px] pb-[15px] pl-[25px] pr-[25px] text-[18px] rounded-full text-[#f2699b] bg-white dark:bg-[#1b2022]"
            href="#"
          >
            Subscribed
          </a>
        </div>
        <!-- /.s4-card -->
      </div>

      <div class="w-full flex items-center justify-center">
        <div class="flex flex-col gap-4 w-full">
          <h1
            class="w-full text-[32px] md:text-[52px] lg:text-[62px] font-bold text-center lg:text-left tracking-tight leading-none"
          >
            <span class="text-[#f2699b]">Support</span>
            your favorites
          </h1>

          <h2
            class="text-[#828282] text-center lg:text-left text-[16px] lg:text-[24px] leading-tight tracking-tighter"
          >
            Subscribe to creators to get all the
            <br />
            exclusive benefits.
          </h2>
          <a
            class="bg-[#F2699B] text-[#ffffff] p-[20px] lg:self-start self-center rounded-full text-[24px] leading-none flex items-center justify-center"
            href="#"
          >
            Support Favorites
          </a>
        </div>
      </div>
    </div>

    <!-- Section-5 -->
    <div
      class="w-full max-w-[800px] flex items-center justify-center p-4 pb-24"
    >
      <div class="w-full h-full flex items-center justify-center">
        <!-- Desktop -->
        <h1
          class="hidden lg:block leading-none tracking-[-1.6px] text-[72px] text-center text-black dark:text-white"
        >
          We help
          <span class="text-[#f2699b]">fans</span>
          to get the content they love and the chance to discover someone
          <span class="text-[#f2699b]">new</span>
        </h1>

        <!-- Tablet -->
        <h1
          class="hidden md:block lg:hidden text-[52px] leading-none tracking-[-1.6px] text-center text-black dark:text-white"
        >
          We help
          <span class="text-[#f2699b]">fans</span>
          to get the content they love and the chance to discover someone
          <span class="text-[#f2699b]">new</span>
        </h1>

        <!-- Mobile -->
        <h1
          class="md:hidden text-center text-[36px] font-600 leading-none tracking-[-1.6px] text-black dark:text-white"
        >
          We help
          <span class="text-[#f2699b]">fans</span>
          to get the content they love and the chance to discover someone
          <span class="text-[#f2699b]">new</span>
        </h1>
      </div>
    </div>

    <!-- Section-6 -->
    <div
      class="w-full flex flex-col items-center justify-center relative clip overflow-hidden"
    >
      <!-- Mobile Squiggles -->
      <div
        class="absolute md:hidden w-[180px] h-auto shrink-0 stroke-[6px] stroke-[#f2699b] top-[140px] left-[-100px] overflow-clip"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 473 184"
          fill="none"
        >
          <path
            d="M-131 3.44287C5.5 36.9429 23 110.452 81.5 117.943C140 125.433 165.74 83.9172 203.72 61.8823C231.823 50.6993 255.285 74.8458 241.351 101.911C229.796 122.727 222.155 150.185 242.164 168.583C270.452 195.872 311.598 171.575 321.337 138.056C333.372 114.14 324.427 56.398 354.427 53.1413C387.5 49.551 418 148.5 469.5 61.8823"
            stroke="#F2699B"
            stroke-width="6"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
        </svg>
      </div>

      <div
        class="absolute md:hidden w-[180px] h-auto shrink-0 stroke-[6px] stroke-[#f2699b] top-[140px] right-[-75px] overflow-clip"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 653 195"
          fill="none"
        >
          <path
            d="M3.5 3.94287C184.5 316.943 246.888 97.9429 318.5 169.554C356.5 207.555 382.27 191.742 407.315 150.413C419.188 131.528 426.629 107.596 419.566 85.9635C410.804 60.3504 383.81 60.1601 377.37 86.1081C369.748 121.659 396.195 159.608 430.032 169.554C472.752 182.112 635.621 198.206 783.972 20.1489"
            stroke="#F2699B"
            stroke-width="10"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
        </svg>
      </div>

      <!-- Desktop Squiggles -->
      <div
        class="absolute hidden md:flex w-[544px] h-[307px] shrink-0 stroke-[6px] stroke-[#f2699b] top-[60px] left-0 overflow-clip"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 473 184"
          fill="none"
        >
          <path
            d="M-131 3.44287C5.5 36.9429 23 110.452 81.5 117.943C140 125.433 165.74 83.9172 203.72 61.8823C231.823 50.6993 255.285 74.8458 241.351 101.911C229.796 122.727 222.155 150.185 242.164 168.583C270.452 195.872 311.598 171.575 321.337 138.056C333.372 114.14 324.427 56.398 354.427 53.1413C387.5 49.551 418 148.5 469.5 61.8823"
            stroke="#F2699B"
            stroke-width="6"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
        </svg>
      </div>

      <div
        class="absolute hidden md:flex w-[781px] h-auto shrink-0 stroke-[6px] stroke-[#f2699b] top-[00px] right-[-75px] overflow-clip"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 653 195"
          fill="none"
        >
          <path
            d="M3.5 3.94287C184.5 316.943 246.888 97.9429 318.5 169.554C356.5 207.555 382.27 191.742 407.315 150.413C419.188 131.528 426.629 107.596 419.566 85.9635C410.804 60.3504 383.81 60.1601 377.37 86.1081C369.748 121.659 396.195 159.608 430.032 169.554C472.752 182.112 635.621 198.206 783.972 20.1489"
            stroke="#F2699B"
            stroke-width="6"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
        </svg>
      </div>

      <div class="hidden md:block">
        <img
          class="size-[100px] absolute left-[60px] top-[120px]"
          src="/images/redesign-temp/girl-s6-p1.svg"
        />
        <img
          class="size-[40px] absolute left-[295px] top-[248px]"
          src="/images/redesign-temp/girl-s6-p2.svg"
        />
        <img
          class="size-[80px] absolute right-[70px] top-[50px]"
          src="/images/redesign-temp/girl-s6-p3.svg"
        />
      </div>

      <div class="max-w-[572px] h-full flex items-center justify-center">
        <div
          class="w-[650px] flex flex-col items-center justify-center gap-y-6 py-[40px] rounded-[32px] bg-[#FBEFF3] dark:bg-[#2b3236]"
          style="z-index: 2; xrow-gap: 2rem"
        >
          <Logo variant="square" />

          <h1
            class="text-[#2F2E2E] dark:text-white font-bold text-center text-[32px] tracking-tight"
          >
            Become a
            <span class="text-[#f2699b] text-[32px]">Member</span>
          </h1>

          <a
            href="#"
            class="flex justify-center items-center rounded-full bg-[#f2699b] py-[12px] px-[24px] text-white text-center text-[24px] tracking-tighter"
          >
            Sign Up
          </a>

          <p
            class="text-[#2F2E2E] dark:text-white text-center text-[18px] leading-tight tracking-tighter"
          >
            Already have an account?
            <br />
            <NuxtLink
              to="/login"
              class="text-[#F2699B] text-[18px] leading-tight"
            >
              Login
            </NuxtLink>
          </p>
        </div>
      </div>
    </div>

    <!-- Section 6.5 :) -->
    <div
      class="w-full flex flex-col items-center justify-center mt-[-30px] mb-[-30px] p-4"
    >
      <a
        href="#"
        class="flex justify-center items-center bg-[#FBEFF3] dark:bg-[#2B3236] rounded-full gap-1 shrink-0 size-[60px] p-[12px 42px]"
      >
        <font-awesome-icon
          icon="fa-arrow-up"
          class="text-[#2F2E2E] dark:text-white text-3xl font-semibold"
        />
      </a>
    </div>

    <!-- Section-7 -->
    <div class="w-full flex flex-col gap-y-6 pb-4">
      <div class="w-full flex flex-col items-center justify-center gap-y-6">
        <div
          class="w-full flex flex-col md:justify-between justify-center items-center gap-y-4"
        >
          <Logo variant="full" />

          <div
            class="text-white text-center text-[18px] md:text-[24px] flex gap-x-4 md:gap-x-8"
          >
            <SiteLegalLinks is-home-page="true" />
          </div>
        </div>
      </div>

      <!-- Horizontal bar -->
      <div class="w-full">
        <div class="w-full" style="background: #2b3236; height: 2px" />
      </div>

      <div class="w-full flex flex-col gap-y-4 justify-between items-center">
        <div class="flex justify-center items-center gap-x-6">
          <a
            href="https://x.com/realfavoritely"
            class="text-black dark:text-white flex size-[50px] justify-center items-center rounded-full border border-[#2B3236]"
          >
            <font-awesome-icon icon="fa-brands fa-x-twitter" />
          </a>
        </div>

        <div>
          <p class="text-[#828282]">
            &copy; {{ new Date().getFullYear() }}, Favoritely Inc. All Rights
            Reserved.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  definePageMeta({
    skipAuth: true,
  })

  useHead({
    title: "Sign Up - favoritely.com",
    meta: [{ name: "description", content: "Sign Up - favoritely.com" }],
  })
</script>

<style>
  /*Nuxt crying "unknown word" unless I have both style-tag and 1 declaration.*/
  .bugfix {
  }
</style>
